import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  GET_WISHLIST_PRODUCTS,
  ADD_TO_WISHLIST,
  DELETE_TO_WISHLIST,
  BASE_URL_NODE,
  GET_NODE_WISHLIST_PRODUCTS,
  ADD_PRODUCT_TO_NODE_WISHLIST,
  DELETE_TO_NODE_WISHLIST,
  DELETE_PRODUCT_TO_NODE_WISHLIST,
  MOVE_TO_NODE_WISHLIST,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  wishlistData: [],
  nodewishlistData: [],
  activeWishlistRequestId: null,
  activeNodeWishlistRequestId: null,
  currentNodeMerchantId: null,
  successMessage: '',
  error: '',
};

// Generate pening , fulfilled and rejected action type
export const fetchWishlistData = createAsyncThunk(
  'wishlist/fetchWishlistData',
  async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + GET_WISHLIST_PRODUCTS,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      if (response.data.status === 200) {
        const filterProducts = response.data.message.product_record_all.filter(
          (product) => product !== null,
        );
        return filterProducts;
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
})
export const fetchWishlistDataOld = createAsyncThunk('wishlist/fetchWishlistData', async (data) => {
    try {
        const response = await axios.post(BASE_URL_SANDBOX + GET_WISHLIST_PRODUCTS, data, { headers: { "Content-Type": "multipart/form-data" } })
        if (response.data.status === 200) {
            const filterProducts = response.data.message.product_record_all.filter(product => product !== null);
            return filterProducts
        }
    } catch (error) {
        throw new Error(error.response.data.message);
    }
})
export const addToWishlist = createAsyncThunk('wishlist/addToWishlist', async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + ADD_TO_WISHLIST,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (response.data.status === 200) {
        return response.data.wish_data;
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);

export const deleteToWishlist = createAsyncThunk(
  'wishlist/deleteToWishlist',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + DELETE_TO_WISHLIST,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (response.data.status === 200) {
        return {
          productId: data.product_id,
          message: response.data.message,
        };
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message );
    }
  }
);

//  for new Node API start

export const fetchNodeWishlistData = createAsyncThunk(
  'wishlist/fetchNodeWishlistData',
  async (data, { rejectWithValue }) => {
    if (data?.user_id === undefined || data?.user_id === null || !data?.merchant_id) {
      return rejectWithValue('User ID and Merchant ID are required.');
    }

    try {
      const response = await axios.post(
        BASE_URL_NODE + GET_NODE_WISHLIST_PRODUCTS,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      if (response.data.status === true) {
        const filterProducts = (Array.isArray(response.data?.data)
          ? response.data.data
          : []).filter(
          (product) => product !== null,
        );
        return filterProducts;
      } else if (response.data.message === "Data not found.") {
        return [];
      }
      return rejectWithValue(
        response.data?.message || 'Unable to retrieve wishlists.',
      );
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || 'Unable to retrieve wishlists.',
      );
    }
})

export const addnodeToWishlist = createAsyncThunk('wishlist/addnodeToWishlist', async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        BASE_URL_NODE + ADD_PRODUCT_TO_NODE_WISHLIST,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (response.data.status === true) {
        return response.data;
      }
      return rejectWithValue(
        response.data?.message || 'Unable to add the product to the wishlist.',
      );
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || 'Unable to add the product to the wishlist.',
      );
    }
  },
);

export const moveToWishlist = createAsyncThunk('wishlist/moveToWishlist', async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_NODE + MOVE_TO_NODE_WISHLIST,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (response.data.status === true) {
        return response.data;
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);


export const deletenodeToWishlist = createAsyncThunk(
  'wishlist/deletenodeToWishlist',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        BASE_URL_NODE + DELETE_PRODUCT_TO_NODE_WISHLIST,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (response.data.status === 200) {
        return {
          wishlistId:data.wishlist_id,
          productId: data.product_id,
          message: response.data.message,
        };
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message );
    }
  }
);
//  for new Node API End



const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    setWishlist: (state, action) => {
      state.wishlistData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWishlistData.pending, (state, action) => {
      state.loading = true;
      state.activeWishlistRequestId = action.meta.requestId;
      state.wishlistData = [];
    });
    builder.addCase(fetchWishlistData.fulfilled, (state, action) => {
      if (state.activeWishlistRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.activeWishlistRequestId = null;
      state.wishlistData = action.payload;
      state.error = '';
    });
    builder.addCase(fetchWishlistData.rejected, (state, action) => {
      if (state.activeWishlistRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.activeWishlistRequestId = null;
      if (!action.meta.aborted) {
        state.error = action.error.message;
      }
    });

    builder.addCase(addToWishlist.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addToWishlist.fulfilled, (state, action) => {
      state.loading = false;
      if (state?.wishlistData?.length >= 1) {
        state.wishlistData = [...state?.wishlistData, action?.payload];
      } else {
        state.wishlistData = action?.payload;
      }

      state.error = ''; // Reset the error message
    });

    builder.addCase(addToWishlist.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteToWishlist.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteToWishlist.fulfilled, (state, action) => {
      state.loading = false;

      if (action.payload && action.payload.productId) {
        state.wishlistData = Array.isArray(state.wishlistData)
          ? state.wishlistData.filter(
              (item) => item && item.id.toString() !== action.payload.productId
            )
          : [];
      }

      state.error = '';
    });

    builder.addCase(deleteToWishlist.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });


    builder.addCase(fetchNodeWishlistData.pending, (state, action) => {
      state.loading = true;
      state.activeNodeWishlistRequestId = action.meta.requestId;
      state.currentNodeMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      state.nodewishlistData = [];
      state.error = '';
    });
    builder.addCase(fetchNodeWishlistData.fulfilled, (state, action) => {
      if (state.activeNodeWishlistRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.activeNodeWishlistRequestId = null;
      state.nodewishlistData = Array.isArray(action.payload) ? action.payload : [];
      state.error = '';
    });
    builder.addCase(fetchNodeWishlistData.rejected, (state, action) => {
      if (state.activeNodeWishlistRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.activeNodeWishlistRequestId = null;
      state.nodewishlistData = [];
      if (!action.meta.aborted) {
        state.error = action.payload || action.error.message;
      }
    });


    builder.addCase(addnodeToWishlist.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addnodeToWishlist.fulfilled, (state, action) => {
      const actionMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      if (
        state.currentNodeMerchantId &&
        actionMerchantId !== state.currentNodeMerchantId
      ) {
        return;
      }

      state.loading = false;
      state.error = ''; // Reset the error message
    });

    builder.addCase(addnodeToWishlist.rejected, (state, action) => {
      const actionMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      if (
        state.currentNodeMerchantId &&
        actionMerchantId !== state.currentNodeMerchantId
      ) {
        return;
      }

      state.loading = false;
      state.error = action.payload || action.error.message;
    });

    builder.addCase(moveToWishlist.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(moveToWishlist.fulfilled, (state, action) => {
      const actionMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      if (
        state.currentNodeMerchantId &&
        actionMerchantId !== state.currentNodeMerchantId
      ) {
        return;
      }

      state.loading = false;
      state.error = ''; // Reset the error message
    });

    builder.addCase(moveToWishlist.rejected, (state, action) => {
      const actionMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      if (
        state.currentNodeMerchantId &&
        actionMerchantId !== state.currentNodeMerchantId
      ) {
        return;
      }

      state.loading = false;
      state.error = action.error.message;
    });

     builder.addCase(deletenodeToWishlist.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletenodeToWishlist.fulfilled, (state, action) => {
      const actionMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      if (
        state.currentNodeMerchantId &&
        actionMerchantId !== state.currentNodeMerchantId
      ) {
        return;
      }

      state.loading = false;
      const { productId, wishlistId } = action.payload;
      if (productId && wishlistId) {
        // 1. Convert wishlistId to an array in case it's a comma-separated string (like "1,10,12")
        const targetIds = wishlistId.toString().split(',').map(id => id.trim());
        state.nodewishlistData = (Array.isArray(state.nodewishlistData)
          ? state.nodewishlistData
          : []).map((wishlist) => {
          // 2. Only modify the wishlist IF its ID is in our target list
          if (targetIds.includes(wishlist.wishlist_id.toString())) {
            return {
              ...wishlist,
              products_data: wishlist.products_data
                ? wishlist.products_data.filter(
                    (product) => product.id.toString() !== productId.toString()
                  )
                : [],
            };
          }
          return wishlist;
        });
      }

      state.error = '';
    });

    builder.addCase(deletenodeToWishlist.rejected, (state, action) => {
      const actionMerchantId = String(
        action.meta.arg?.merchant_id ?? '',
      ).trim().toUpperCase();
      if (
        state.currentNodeMerchantId &&
        actionMerchantId !== state.currentNodeMerchantId
      ) {
        return;
      }

      state.loading = false;
      state.error = action.error.message;
    });


  },
});

export const { setWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
